// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"8e5dea00","703":"52fd6b07","787":"c62cb727"}[chunkId] + ".chunk.js";
};